import { defineComponent as _defineComponent } from 'vue'
import { vModelText as _vModelText, withKeys as _withKeys, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/login/down.png'


const _withScopeId = n => (_pushScopeId("data-v-63a6ca5d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"position":"relative","height":"100%"} }
const _hoisted_2 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_3 = { style: {"position":"relative"} }
const _hoisted_4 = ["onKeydown", "placeholder"]
const _hoisted_5 = { style: {"flex":"1","margin-left":"24px"} }
const _hoisted_6 = { class: "down" }
const _hoisted_7 = {
  key: 0,
  style: {"height":"100%","position":"relative"}
}
const _hoisted_8 = { style: {"position":"absolute","top":"50%","left":"50%","transform":"translate(-50%,-50%)","color":"var(--el-text-color-secondary)"} }
const _hoisted_9 = { style: {"margin-right":"24px"} }
const _hoisted_10 = ["src"]
const _hoisted_11 = { style: {"width":"100%","margin-right":"24px"} }
const _hoisted_12 = { style: {"margin":"2px 0 16px 0","font-size":"18px"} }
const _hoisted_13 = { style: {"color":"#5E6A71","font-size":"12px"} }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  key: 1,
  style: {"margin-top":"20px","display":"flex","justify-content":"space-between","align-items":"center"}
}

import type { PropType } from 'vue'
import { reactive,watch,computed,ref } from 'vue'
import { findSysFileList,getFileSource } from '../loginApi'
// import { SystemType } from '../types'
import { useStore } from 'vuex';

export default /*#__PURE__*/_defineComponent({
  __name: 'Download',
  props: {
  systemList: {
    type: Array as PropType<any[]>,
    required: true, // 必须传递
  },
},
  setup(__props) {

const props = __props;

const store = useStore();

const data = reactive<{
  list: { fileName: string, icon: string, id: string, size: string,ossUrl: string }[],
  value: string,
  commandValue: string,
  loading: boolean
}>({
  list: [],
  value: '',
  commandValue: '',
  loading: false
})
const page = reactive({
  pageNo: 1,
  pageSize: 10,
  total: 0
})
function getList() {
  data.loading = true
  findSysFileList({ fileName: data.value, systemId: data.commandValue,...page }).then(res => {
    
    data.list = res.data.records
    data.list.forEach(e => {
      if (e.fileName) {
        const suffixNameArr = e.ossUrl.split('.')
        const suffixName = suffixNameArr[suffixNameArr.length - 1]
        if (suffixName == 'jpg' || suffixName == 'jpeg' || suffixName == 'gif' || suffixName == 'png') {
          // e.icon = new URL('@/assets/img/login/img.png',import.meta.url).href
          e.icon = require('@/assets/img/login/img.png')
        } else if(suffixName == 'apk' || suffixName == 'pdf' || suffixName == 'word' || suffixName == 'excel' || suffixName == 'ipa' || suffixName == 'mp4' || suffixName == 'zip'){
          // e.icon = new URL('@/assets/img/login/' + suffixName + '.png', import.meta.url).href
          e.icon = require('@/assets/img/login/' + suffixName + '.png')
        } else {
          // e.icon = new URL('@/assets/img/login/else.png',import.meta.url).href
          e.icon = require('@/assets/img/login/else.png')
        }
      }
    })
    page.total = res.data.total
  }).finally(()=>data.loading = false)
}
const downLoading = ref({})
function downLoad(item:any,i:number) {
  // downloadFile({fileName}).then(res => {
  //   const link = document.createElement('a')
  //   link.href = window.URL.createObjectURL(new Blob([res]))
  //   document.body.appendChild(link)
  //   link.download = fileName
  //   link.click()
  // })
  if(downLoading.value[item.id]) return
  downLoading.value[item.id] = true
  fetch(item.ossUrl)
    .then(response => response.blob())
    .then(blob => {
      const urlObject = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = urlObject
      a.download = item.fileName + item.ossUrl.slice(item.ossUrl.lastIndexOf('.')).toLocaleLowerCase() // 这里设置文件名
      a.style.display = 'none'
      document.body.appendChild(a)
      a.click()
      setTimeout(() => {
        window.URL.revokeObjectURL(urlObject) // 释放URL对象
        a.remove()
      }, 0)
    })
    .catch(error => console.error('Error:', error)).finally(() => {
      downLoading.value[item.id] = false
    })
}
const sourceList = ref<any>([])
const getSearchList = () => {
  getFileSource().then(res => {
    sourceList.value = res.data
  })
}
const firstTimeLogin = computed(()=>{
  return store.state.firstTimeLogin
})
const isToken = computed(() => store.getters.getoken);
watch(
  firstTimeLogin,
  (newData) => {
      if (!newData && isToken.value) {
        getList();
        getSearchList()
      }
    },
    { immediate: true }
  );


return (_ctx: any,_cache: any) => {
  const _component_Search = _resolveComponent("Search")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withDirectives(_createElementVNode("input", {
          class: "searchInput",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((data.value) = $event)),
          onKeydown: _withKeys(getList, ["enter"]),
          type: "text",
          placeholder: _ctx.$t('login.pleaseSearch'),
          style: {"background":"transparent"}
        }, null, 40, _hoisted_4), [
          [_vModelText, data.value]
        ]),
        _createVNode(_component_el_icon, {
          style: {"cursor":"pointer","font-size":"20px","position":"absolute","top":"18px","right":"0","padding-left":"20px","color":"#5E6A71"},
          onClick: getList
        }, {
          default: _withCtx(() => [
            _createVNode(_component_Search)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_el_select, {
          modelValue: data.commandValue,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((data.commandValue) = $event)),
          class: "m-2",
          onChange: getList,
          placeholder: _ctx.$t('login.selectPlatform'),
          size: "large",
          clearable: "",
          style: {"width":"100%","height":"48px"}
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sourceList.value, (item) => {
              return (_openBlock(), _createBlock(_component_el_option, {
                key: item.id,
                label: item.name,
                value: item.id
              }, null, 8, ["label", "value"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue", "placeholder"])
      ])
    ]),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_6, [
      (!data.list.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('login.noData')), 1)
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.list, (item, i) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "downBox",
          justify: "space-between",
          key: item.id
        }, [
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("img", {
              src: item.icon,
              alt: ""
            }, null, 8, _hoisted_10)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("h4", _hoisted_12, _toDisplayString(item.fileName), 1),
            _createElementVNode("span", _hoisted_13, _toDisplayString(item.size) + "KB", 1)
          ]),
          _withDirectives((_openBlock(), _createElementBlock("div", {
            style: {"line-height":"64px","cursor":"pointer"},
            onClick: ($event: any) => (downLoad(item,i))
          }, _hoisted_16, 8, _hoisted_14)), [
            [_directive_loading, downLoading.value[item.id]]
          ])
        ]))
      }), 128)),
      (page.total >= 10)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createElementVNode("div", null, _toDisplayString(_ctx.$t('total', { total: page.total })), 1),
            _createVNode(_component_el_pagination, {
              "current-page": page.pageNo,
              "onUpdate:currentPage": _cache[2] || (_cache[2] = ($event: any) => ((page.pageNo) = $event)),
              "page-size": page.pageSize,
              "onUpdate:pageSize": _cache[3] || (_cache[3] = ($event: any) => ((page.pageSize) = $event)),
              background: "",
              "page-sizes": [100, 200, 300, 400],
              layout: "prev, pager, next, jumper",
              total: page.total,
              onSizeChange: getList,
              onCurrentChange: getList
            }, null, 8, ["current-page", "page-size", "total"])
          ]))
        : _createCommentVNode("", true)
    ])), [
      [_directive_loading, data.loading]
    ])
  ]))
}
}

})